// Section for import npm components ------------------------------------------------------------------------------------
import React, { useContext } from 'react';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import highchartsAccessibility from 'highcharts/modules/accessibility';
import HighchartsReact from 'highcharts-react-official';

// MUI components
import Box from '@mui/material/Box';

// Section for import custom components --------------------------------------------------------------------------------
import { MansionReviewContext } from '@providers/MansionDetail/MansionReview/MansionReviewProvider';

// Section for type definition -----------------------------------------------------------------------------------------

// init the module
highchartsAccessibility(Highcharts);
HighchartsMore(Highcharts);

export default function Chart() {
  const mansionReviewContext = useContext(MansionReviewContext);
  // @ts-ignore
  const { mansionReview } = mansionReviewContext;

  const options = {
    chart: {
      polar: true,
      height: 225,
    },
    legend: {
      enabled: false,
    },
    title: {
      text: null,
      style: {
        display: 'none',
      },
    },
    credits: {
      enabled: false,
    },
    pane: {
      startAngle: 0,
      endAngle: 360,
    },

    xAxis: {
      categories: [
        mansionReview.scoreTotal.exteriorAndFacilities.title,
        mansionReview.scoreTotal.roomFacilities.title,
        mansionReview.scoreTotal.shoppingAndEating.title,
        mansionReview.scoreTotal.convenientLiving.title,
        mansionReview.scoreTotal.convenientTransportation.title,
        mansionReview.scoreTotal.LivingEnvironment.title,
      ],
      lineWidth: 0,
    },
    yAxis: {
      gridLineInterpolation: 'polygon',
      /* ラベル非表示 */
      labels: {
        enabled: false,
      },
      lineWidth: 0,
      min: 0,
      max: 5,
      tickAmount: 6,
    },

    series: [
      {
        type: 'area',
        name: '評価',
        color: 'rgba(225,50,60,0.5)',
        data: [
          mansionReview.scoreTotal.exteriorAndFacilities.score,
          mansionReview.scoreTotal.roomFacilities.score,
          mansionReview.scoreTotal.shoppingAndEating.score,
          mansionReview.scoreTotal.convenientLiving.score,
          mansionReview.scoreTotal.convenientTransportation.score,
          mansionReview.scoreTotal.LivingEnvironment.score,
        ],
      },
    ],
  };

  return (
    <Box>
      <Box>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </Box>
    </Box>
  );
}
